var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificaWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9010_24435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9992 63C51.7162 63 65.2679 49.1208 65.2679 32C65.2679 14.8792 51.7162 1 34.9992 1C18.2822 1 4.73047 14.8792 4.73047 32C4.73047 49.1208 18.2822 63 34.9992 63Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38034 32.6656C5.38034 15.5436 18.931 1.66557 35.6491 1.66557C43.8427 1.66557 51.2723 4.99942 56.723 10.4169C51.2225 4.60967 43.5236 1 34.9992 1C18.2822 1 4.73047 14.8792 4.73047 32C4.73047 40.7304 8.25499 48.6153 13.9253 54.2486C8.63847 48.6662 5.38034 41.0572 5.38034 32.6656Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2132 61.8337C53.0901 58.9886 60.9207 51.1456 63.93 41.1351L37.4171 13.9816L33.8721 39.1354L38.0143 43.3777L31.981 49.5926L43.2132 61.8337Z",
    fill: "url(#paint0_linear_9010_24435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7363 46.4657C30.7363 45.2395 31.152 44.2052 31.9804 43.3627C32.8118 42.5203 33.8159 42.1005 34.9985 42.1005C36.1783 42.1005 37.1853 42.5263 38.0137 43.3747C38.8451 44.2262 39.2578 45.2545 39.2578 46.4657C39.2578 47.6769 38.8392 48.7143 38.002 49.5807C37.1648 50.4471 36.1636 50.8789 34.9985 50.8789C33.8159 50.8789 32.8118 50.4501 31.9804 49.5927C31.152 48.7352 30.7363 47.6919 30.7363 46.4657ZM38.8304 33.592C38.8304 35.5528 38.5143 37.0098 37.8849 37.9572C37.2555 38.9046 36.2924 39.3783 35.0015 39.3783C33.7251 39.3783 32.7679 38.8986 32.1268 37.9422C31.4887 36.9858 31.1696 35.5348 31.1696 33.589V18.8265C31.1696 16.9138 31.4887 15.4837 32.1268 14.5363C32.765 13.5889 33.7222 13.1152 35.0015 13.1152C36.2924 13.1152 37.2555 13.5859 37.8849 14.5243C38.5143 15.4657 38.8304 16.8988 38.8304 18.8265V33.592Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9010_24435",
    x: 0.730469,
    y: 0,
    width: 68.5371,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9010_24435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9010_24435",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9010_24435",
    x1: 33.8288,
    y1: 31.2667,
    x2: 56.5608,
    y2: 53.4625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaWarning);
export default __webpack_public_path__ + "static/media/notifica_warning.3aa7a7976ffa8c62eeae8efa1642f481.svg";
export { ForwardRef as ReactComponent };